import {
  Card,
  CardContent,
  CardTitle,
  Grid,
  GridCol,
  GridRow,
  Text,
  Container,
} from '@legalshield/adonis-ux-framework';
import React from 'react';

const EmptyContent: React.FC = () => {
  return (
    <Grid>
      <GridRow>
        <GridCol>
          <Container>
            <Card>
              <CardContent padding={6}>
                <CardTitle>{string_table.EMPTY_CARD_TITLE}</CardTitle>
                <Text text={string_table.EMPTY_CARD_TEXT} />
              </CardContent>
            </Card>
          </Container>
        </GridCol>
      </GridRow>
    </Grid>
  );
};

export default EmptyContent;
